import { CONFIGURATION, CONFIGURATION_TYPE } from './types';
import store from '../store';
import Logger from '../../../common/logger';
import { VIEWS } from '../../components/views/types';

export const getConfigurationType = view => {
    if (view.toUpperCase().indexOf('POPUP') !== -1) {
        return CONFIGURATION_TYPE.POPUP;
    } else if (view.toUpperCase().indexOf('EIP') !== -1) {
        return CONFIGURATION_TYPE.EIP;
    } else {
        return CONFIGURATION_TYPE.WIDGET;
    }
};

const allowConfigToLoad = (configurationType, config) => {
    const state = store.getState();
    let allow = false;
    switch (configurationType) {
        case CONFIGURATION_TYPE.WIDGET:
            if (!state.config.widget || state.config.widget.temporary) {
                allow = true;
            } else if (state.widget && state.widget.currentView === VIEWS.PRELOADER) {
                allow = true;
            }
            break;
        case CONFIGURATION_TYPE.POPUP:
            if (!state.config.popup || state.config.popup.length < 1) {
                allow = true;
            } else if (state.popup && state.popup.currentView === VIEWS.PRELOADER) {
                allow = true;
            } else if (state.config.popup.length > 0) {
                if (
                    config.eipView &&
                    (state.config.popup.find(p => !p.eipView) ||
                        !state.config.popup.find(p => p.eipView === config.eipView))
                ) {
                    allow = true;
                } else if (state.config.popup.find(p => p.defaultView !== config.defaultView)) {
                    allow = true;
                }
            }
            break;
        case CONFIGURATION_TYPE.EIP:
            if (!state.config.eip) {
                allow = true;
            }
            break;
        default:
            break;
    }

    Logger.log(`allowConfigToLoad: [configType=${configurationType}, allow=${allow}]`);

    return allow;
};

export const generateId = () => {
    return 'xxxxxxxx'.replace(/[x]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

export const loadConfig = ({ config, events }) => {
    const configurationType = getConfigurationType(config.defaultView);

    if (allowConfigToLoad(configurationType, config) === false) {
        return false;
    }

    Logger.setDebugGWE(config.debugGWE || false);

    if (events && events.beforeLoad) {
        events.beforeLoad(configurationType);
    }

    const state = store.getState();
    switch (configurationType) {
        case CONFIGURATION_TYPE.POPUP:
            {
                const configs = state.config.popup || [];
                configs.push({ ...config, id: config.id ? config.id : generateId() });
                store.dispatch({
                    type: CONFIGURATION.LOAD_POPUP,
                    data: configs
                });
            }
            break;
        case CONFIGURATION_TYPE.EIP:
            store.dispatch({
                type: CONFIGURATION.LOAD_EIP,
                data: config
            });
            break;
        default:
            store.dispatch({
                type: CONFIGURATION.LOAD_WIDGET,
                data: config
            });
    }

    if (events && events.afterLoad) {
        events.afterLoad();
    }

    return true;
};

export const updateWidgetConfig = configProperty => {
    store.dispatch({
        type: CONFIGURATION.UPDATE_WIDGET,
        data: configProperty
    });
};

export const resetConfig = () => {
    store.dispatch({
        type: CONFIGURATION.RESET
    });
};

export const resetWidgetConfig = () => {
    store.dispatch({
        type: CONFIGURATION.RESET_WIDGET
    });
};

export const resetPopupConfig = () => {
    store.dispatch({
        type: CONFIGURATION.RESET_POPUP
    });
};

export const removePopupConfig = id => {
    const state = store.getState();
    const configs = state.config.popup || [];
    store.dispatch({
        type: CONFIGURATION.LOAD_POPUP,
        data: configs.filter(c => c.id !== id)
    });
};

export const resetEIPConfig = () => {
    store.dispatch({
        type: CONFIGURATION.RESET_EIP
    });
};

export const getPopupConfig = configId => {
    const state = store.getState();
    const configs = state.config.popup || [];
    return configs.filter(c => c.id === configId);
};
